import baseRequest from "../_core/baseRequest";

export default {
    getShiftList: params => baseRequest.post("/shifts/list", params),
    getShiftForOperationPage: params => {
        const queryParams = new URLSearchParams();
        if (params?.forecastDate) queryParams.append("forecastDate", params.forecastDate);
        if (params?.city && params.city !== "all") queryParams.append("city", params.city);
        if (params?.company && params.company !== "all")
            queryParams.append("company", params.company);
        (params?.subcompanies || []).forEach(id => queryParams.append("subcompanies", id));
        (params?.poolIds || []).forEach(id => queryParams.append("poolIds", id));
        if (params?.searchText) queryParams.append("searchText", params.searchText);
        if (params?.zoneManagementId)
            queryParams.append("zoneManagementId", params.zoneManagementId);
        if (params?.zoneId) queryParams.append("zoneId", params.zoneId);
        return baseRequest.get(
            `/shifts/operation-page?${queryParams.toString().replaceAll("+", "%20")}`
        );
    },
    getSnapshotList: params => baseRequest.post("/shifts/snapshot-list", params),
    downloadShiftExcelFile: params => baseRequest.post("/shifts/export", params, true),
    downloadShiftExcelFileSnapshot: params =>
        baseRequest.post("/shifts/snapshot-export", params, true),
    deleteShift: params => baseRequest.post(`/shifts/delete`, params),
    updateShift: params => baseRequest.post("/shifts/update", params),
    getShiftScoreList: params => baseRequest.post("/company/shift-report-list", params),
    exportShiftScoreListByCurrentStatus: params =>
        baseRequest.post("/company/export-shift-report-list-by-current-status", params, true),
    getFutureShiftsList: params => baseRequest.post("/shifts/future-shift-list", params),
    updateShiftCompanyAndSubCompany: params => baseRequest.put("/shifts/update-company", params),
    updateShiftCourier: params => baseRequest.put("/shifts/update-courier", params),
    getShiftScoreObjectionList: params =>
        baseRequest.post("/shifts/reports/objections/list", params),
    createShiftScoreObjection: params => baseRequest.post("/shifts/reports/objections", params),
    getShiftScoreObjection: params =>
        baseRequest.get(`/shifts/reports/objections/${params.objectionId}`),
    createShiftScoreObjectionNote: params =>
        baseRequest.post(`shifts/reports/objections/${params.objectionId}/notes`, params),
    updateShiftScoreObjectionRevision: params =>
        baseRequest.put(`shifts/reports/objections/${params.objectionId}/revision`, params),
    updateShiftScoreObjectionApproval: params =>
        baseRequest.put(`shifts/reports/objections/${params.objectionId}/approval`, params),
    approveShiftReport: params =>
        baseRequest.put(`shifts/reports/${params.reportId}/approve`, params),
    getShiftReportByTcknAndDate: params =>
        baseRequest.post("/shifts/reports/get-by-tckn-and-date", params),
    getShiftReportByCourierIdAndDate: params => baseRequest.post("/shifts/get-by-date", params),
    getShiftCompliance: params => baseRequest.post("/shifts/reports/compliance/list", params),
    getComplianceCouriers: params =>
        baseRequest.post("/shifts/reports/compliance/courier-list", params),
    getWaitingApproveCount: () => baseRequest.get("/shifts/reports/waiting-approve-count"),
    getObjectionsCount: params => baseRequest.post("/shifts/reports/objections/list", params),

    getDayOffList: params => baseRequest.post("/shifts/day-off/list", params),
    downloadDayOffExcelFile: params => baseRequest.post("/shifts/day-off/export", params, true),
    updateDayOff: params => baseRequest.post("/shifts/day-off/update", params),
    updateDayOffApproval: params =>
        baseRequest.put(`shifts/day-off/${params.dayOffId}/approval`, params),
    deleteDayOff: params => baseRequest.post(`/shifts/day-off/delete`, params),
    getQuickReactionCourierList: params =>
        baseRequest.post("/shifts/suggestion/quick-reaction-couriers", params),
    postQuickReactionCourierList: params =>
        baseRequest.post("/shifts/suggestion/quick-reaction-to-forecast", params),
    reportShiftProblem: params => baseRequest.post("/shifts/report-issue", params),
    importShiftExcel: params => baseRequest.post("/shifts/import", params, true),
    createShiftReport: params => baseRequest.post("/shifts/reports", params),
    createManuelShift: params => baseRequest.post("/shifts", params)
};
